<template>
  <div class="barcode"></div>
</template>

<script>
import Quagga from "quagga";

export default {
  data() {
    return {
      lastDetected: 0,
      detected: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      Quagga.CameraAccess.enumerateVideoDevices()
        .then(devices => {
          for (let i = 0; i < devices.length; i++) {
            if (devices[i].label.indexOf("back") >= 0) {
              return devices[i].deviceId;
            }
          }
        })
        .then(deviceId => {
          Quagga.init(
            {
              inputStream: {
                name: "Live",
                type: "LiveStream",
                target: this.$el,
                constraints: {
                  width: { min: 640 },
                  height: { min: 480 },
                  aspectRatio: { min: 1, max: 100 },
                  facingMode: "environment",
                  deviceId: deviceId
                }
              },
              decoder: {
                readers: [
                  {
                    format: "ean_reader",
                    config: {}
                  }
                ],
                debug: {
                  drawBoundingBox: true,
                  showFrequency: true,
                  drawScanline: true,
                  showPattern: true
                }
              },
              numOfWorkers: 4,
              locator: {
                patchSize: "medium",
                halfSample: true,
                debug: true
              },
              locate: true,
              debug: true
            },
            function(err) {
              if (err) {
                console.log(err);
                return;
              }
              console.log("Initialization finished. Ready to start");
              Quagga.start();
            }
          );
        });

      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();

      Quagga.onDetected(result => {
        const code = result.codeResult.code;
        if (this.lastDetected === code) {
          return;
        }
        const count = this.detected.reduce((count, item) => {
          return item === code ? count + 1 : count;
        }, 0);
        if (count > 9) {
          this.detected.length = 0;
          this.lastDetected = code;
          this.$emit("code", code);
          navigator.vibrate([200]);
          const osc = audioContext.createOscillator(); // instantiate an oscillator
          osc.type = "square"; // this is the default - also square, sawtooth, triangle
          osc.frequency.value = 880; // Hz
          osc.connect(audioContext.destination); // connect it to the destination
          osc.start(); // start the oscillator
          osc.stop(audioContext.currentTime + 0.15);
        } else {
          this.detected.push(code);
        }
      });

      Quagga.onProcessed(result => {
        let drawingCtx = Quagga.canvas.ctx.overlay;
        let drawingCanvas = Quagga.canvas.dom.overlay;

        if (result) {
          if (result.boxes) {
            drawingCtx.clearRect(
              0,
              0,
              parseInt(drawingCanvas.getAttribute("width")),
              parseInt(drawingCanvas.getAttribute("height"))
            );
            result.boxes
              .filter(function(box) {
                return box !== result.box;
              })
              .forEach(function(box) {
                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                  color: "green",
                  lineWidth: 2
                });
              });
          }

          if (result.box) {
            Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
              color: "#00F",
              lineWidth: 2
            });
          }

          if (result.codeResult && result.codeResult.code) {
            Quagga.ImageDebug.drawPath(
              result.line,
              { x: "x", y: "y" },
              drawingCtx,
              { color: "red", lineWidth: 3 }
            );
          }
        }
      });
    });
  },
  beforeDestroy() {
    Quagga.stop();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.barcode {
  position: relative;
}

.drawingBuffer {
  position: absolute;
  z-index: 999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
</style>
